import { jsx as m } from "react/jsx-runtime";
import { c as l } from "./clsx-OuTLNxxd.js";
import { s } from "./columns.module-Du2wMSpT.js";
const u = {
  auto: "",
  1: "is-1",
  2: "is-2",
  3: "is-3",
  4: "is-4",
  5: "is-5",
  6: "is-6",
  7: "is-7",
  8: "is-8",
  9: "is-9",
  10: "is-10",
  11: "is-11",
  12: "is-12"
}, N = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "8",
  "10",
  "11",
  "12",
  "14",
  "16",
  "18",
  "20",
  "24",
  "32",
  "40",
  "48",
  "56",
  "64",
  "72",
  "80"
], C = {
  auto: "",
  1: "is-offset-1",
  2: "is-offset-2",
  3: "is-offset-3",
  4: "is-offset-4",
  5: "is-offset-5",
  6: "is-offset-6",
  7: "is-offset-7",
  8: "is-offset-8",
  9: "is-offset-9",
  10: "is-offset-10",
  11: "is-offset-11",
  12: "is-offset-12"
};
function O({
  size: i = "auto",
  offset: f = "auto",
  isNarrow: t = !1,
  className: e = "",
  children: a,
  gap: o,
  hiddenContentOnMobile: n = !1,
  ...c
}) {
  const r = l(
    s.column,
    s[u[i]],
    s[C[f]],
    t && s["is-narrow"],
    o && s[`gap-${o}`],
    n && s["hidden-content-on-mobile"],
    e
  );
  return /* @__PURE__ */ m("div", { className: r, ...c, children: a });
}
export {
  O as C,
  u as a,
  N as b,
  C as c
};
